export const company = {
  name: "GAVITO technic s.r.o.",
  tagline: "Vzdělávací agentura",
  phone: "+420 739 921 359",
  email: "info@gavito.cz",
  hours: "9:00–17:00",
  address: "Potocká 58/7, Kohoutovice, 623 00 Brno",
  ico: "03505448",
  dic: "CZ03505448",
  rejstrik: "Zapsáno v obchodním rejstříku vedeném Krajským soudem v Brně, sp. zn. C 85172",
};

export const stats = [
  { value: "2 000+", label: "vyškolených lidí za poslední rok" },
  { value: "10+", label: "let zkušeností na trhu" },
  { value: "100 %", label: "zaměřeno na praxi, ne na teorii" },
];

// Poster pro video přehrávač (tmavá abstraktní textura – žádné fotobankové portréty).
export const videoPoster =
  "https://images.unsplash.com/photo-1614850523011-8f49ffc73908?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600";
